import React from 'react';

const Profile=()=> {
    return (
        <div>
            <h1>Hi i am Profile</h1>
        </div>
    );
}

export default Profile